import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";


export default function GuideLines({ isOpen, onClose }) {

  const handleClose = () => {
        onClose(); 
      };
  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-md max-w-lg w-full relative">
        <div className="flex justify-between items-center mb-4" style={{ color: '#333333' }}>
  <h2 className="text-sm font-bold">Guidelines</h2> 
  <button onClick={handleClose}>
    <svg className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
</div>


 <div className="mb-4 text-xs"> {/* Apply text size 14px */}
  <p className="mb-2">You may update up to 1000 records in the template file format. Please ensure there is no missing or duplicate data, and all data is in the required format. Note KYC Override can only be done for Farmers whose Mobile Number has been verified and whose KYC is still pending.</p> {/* Apply vertical spacing */}
 
</div>


        <div className="flex justify-end">

         
        <Button variant="contained"  onClick={handleClose} style={{ color: '#FFFFFF', backgroundColor: '#009CA7',fontSize: '14px' }}>Close</Button>
        </div>
      </div>
    </div>
      </Dialog>
    </React.Fragment>
  );
}
